module.exports = __webpack_public_path__ + "static/media/step1.a937eb97.png";